import { createFileRoute, redirect } from "@tanstack/react-router";
import { LEGACY_UPLOAD_REDIRECTS } from "@/lib/legacy-uploads";

export const Route = createFileRoute("/wp-content/$")({
  beforeLoad: ({ params }) => {
    const legacyPath = params._splat?.replace(/^\/+/, "") ?? "";
    const target = LEGACY_UPLOAD_REDIRECTS[legacyPath];
    throw redirect({
      href: target ?? "/",
      statusCode: 301,
      replace: true,
    });
  },
});
